<template>
  <div class="pa-5 pt-2">
    <v-row>
      <v-col cols="12">
        <profit-summary-data-table :refresh="isRefresh" />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import ProfitSummaryDataTable from './DataTable'
export default {
  name: 'profit-summary',
  components: {
    ProfitSummaryDataTable
  },
  props: [
    'refresh'
  ],
  data() {
    return {
      isRefresh: 1
    }
  },
  methods: {
    reload() {
      this.isRefresh += 1
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?a18ef77e